import { MinusOutlined, PlusOutlined } from '@ant-design/icons'
import { Button, Card, Col, Collapse, Image, Modal, Row } from 'antd'
import { useEffect, useState } from 'react'
import commonServices from 'src/services/common.service'
import extraServiceServices from 'src/services/extraService.service'
import PriceTab from '../TrackingForm/PriceTab'
import { IMAGE_HOST } from 'src/configs/API'

const { Panel } = Collapse
const isMobileDevice = () => /iPhone|iPad|iPod|Android/i.test(navigator.userAgent)

const Service = ({ data }) => {
	const titleTexts = data?.text?.title?.split(' ') || []
	const redText = titleTexts.length > 2 && `${titleTexts[0]} ${titleTexts[1]}`
	const blackText = redText && titleTexts.slice(2).join(' ')
	const [loading, setLoading] = useState(false)
	const [listExtraServices, setListExtraServices] = useState([])
	const [listPackServices, setListPackServices] = useState([])
	const [activeKeys, setActiveKeys] = useState([])
	const [priceModalVisible, setPriceModalVisible] = useState(false)
	const [banner, setBanner] = useState(null)

	const getListExtraService = () => {
		setLoading(true)
		extraServiceServices
			.getExtraServiceList()
			.then((res) => {
				setListExtraServices(res?.ExtraServices)
				setLoading(false)
			})
			.catch((err) => {
				console.log(err)
			})
	}
	const getListPackService = () => {
		setLoading(true)
		extraServiceServices
			.getPackServiceList()
			.then((res) => {
				setListPackServices(res?.Data)
				setLoading(false)
			})
			.catch((err) => {
				console.log(err)
			})
	}

	useEffect(() => {
		getListExtraService()
		getListPackService()
	}, [])

	useEffect(() => {
		if (data)
			commonServices.getImage(data.image).then((response) => {
				setBanner(response?.Data?.Image)
			})
	}, [data])

	const onChangeSetActiveKey = (key) => {
		setActiveKeys(key)
	}

	const togglePriceModal = () => setPriceModalVisible(!priceModalVisible)

	return (
		<div className="service">
			<Modal
				width={678}
				getContainer=".service"
				title={null}
				open={priceModalVisible}
				footer={null}
				onCancel={togglePriceModal}
			>
				<div className="tracking__form">
					<PriceTab />
				</div>
			</Modal>
			<Row
				className="service-content"
				justify="space-around"
				gutter={{
					xs: 8,
					sm: 16,
					md: 24,
					lg: 32,
				}}
			>
				<Col className="gutter-row" span={24}>
					{data.id != 'service_6' && (
						<Row className="row_button">
							<Button
								className="service__page-btn"
								type="primary"
								color="#CC0000"
								style={{ fontSize: 16 }}
								onClick={togglePriceModal}
							>
								Tính giá
							</Button>
						</Row>
					)}
					<div className="content">
						<Image
							className="banner"
							preview={false}
							src={banner ? IMAGE_HOST + banner : ''}
							alt="banner"
						/>
						{data?.id !== 'service_6' ? (
							<div className="descript">
								{/* <span>{redText + ' '}</span>
								<span style={{ color: '#CC0000' }}>{blackText}</span> */}
								<h1 className='detail-title'>{data?.text?.title}</h1>
								<p dangerouslySetInnerHTML={{ __html: data?.text?.descript }}></p>
							</div>
						) : (
							<div className="descript service__6">
								<span>{redText + ' '}</span>
								<span>{blackText}</span>
								<p
									style={{ textAlign: 'left' }}
									dangerouslySetInnerHTML={{ __html: data?.text?.descript }}
								></p>
							</div>
						)}
						{data?.id !== 'service_5' && data?.id !== 'service_6' && (
							<div className="icons">
								{data?.icons.map((item, index) => {
									return (
										<div key={index} className="icon-items">
											<Image className="icon" preview={false} src={item.image} alt="icon" />
											<div
												className="text"
												dangerouslySetInnerHTML={{ __html: item.descript }}
												style={{ padding: '10px 20px' }}
											></div>
										</div>
									)
								})}
							</div>
						)}
						{data?.id == 'service_5' &&
							listExtraServices?.map((item, index) => {
								return (
									<Row key={item?.id}>
										<Col xl={3} lg={24} md={24} sm={24} xs={24}></Col>
										<Col xl={18} lg={24} md={24} sm={24} xs={24}>
											<Card
												className="card-item-dich-vu-gia-tang"
												style={{
													background: '#FFFFFF',
													borderRadius: 12,
													boxShadow: '0px 4px 30px rgba(0, 0, 0, 0.1)',
													marginBottom: 10,
												}}
											>
												<Collapse
													bordered={false}
													ghost
													destroyInactivePanel={true}
													activeKey={activeKeys}
													onChange={onChangeSetActiveKey}
													expandIconPosition="end"
													expandIcon={({ isActive }) =>
														isActive ? (
															<div
																style={{
																	width: 23,
																	height: 24,
																	background: '#CC0000',
																	borderRadius: 4,
																	display: 'flex',
																	alignItems: 'center',
																	justifyContent: 'center',
																}}
															>
																<MinusOutlined style={{ color: 'white' }} />
															</div>
														) : (
															<div
																style={{
																	width: 23,
																	height: 24,
																	background: '#CC0000',
																	borderRadius: 4,
																	display: 'flex',
																	alignItems: 'center',
																	justifyContent: 'center',
																}}
															>
																<PlusOutlined style={{ color: 'white' }} />
															</div>
														)
													}
												>
													<Panel
														forceRender={true}
														key={item?.Id}
														header={
															<div style={{ borderLeft: '6px solid #CC0000' }}>
																<span className="ant-collapse-header-text">
																	{isMobileDevice()
																		? activeKeys.includes(item?.Id.toString())
																			? item?.Title
																			: item?.Title.length > 25
																			? item?.Title.substr(0, 25) + '...'
																			: item?.Title
																		: item?.Title}
																</span>
															</div>
														}
													>
														<span className="ant-collapse-content-description">
															{item?.Description}
														</span>
													</Panel>
												</Collapse>
											</Card>
										</Col>
										<Col xl={3} lg={24} md={24} sm={24} xs={24}></Col>
									</Row>
								)
							})}
						{data?.id == 'service_6' &&
							listPackServices?.map((item, index) => {
								return (
									<Row key={item?.id}>
										<Col xl={3} lg={24} md={24} sm={24} xs={24}></Col>
										<Col xl={18} lg={24} md={24} sm={24} xs={24}>
											<Card
												className="card-item-dich-vu-gia-tang"
												style={{
													background: '#FFFFFF',
													borderRadius: 12,
													boxShadow: '0px 4px 30px rgba(0, 0, 0, 0.1)',
													marginBottom: 10,
												}}
											>
												<Collapse
													bordered={false}
													ghost
													destroyInactivePanel={true}
													activeKey={activeKeys}
													onChange={onChangeSetActiveKey}
													expandIconPosition="end"
													expandIcon={({ isActive }) =>
														isActive ? (
															<div
																style={{
																	width: 23,
																	height: 24,
																	background: '#CC0000',
																	borderRadius: 4,
																	display: 'flex',
																	alignItems: 'center',
																	justifyContent: 'center',
																}}
															>
																<MinusOutlined style={{ color: 'white' }} />
															</div>
														) : (
															<div
																style={{
																	width: 23,
																	height: 24,
																	background: '#CC0000',
																	borderRadius: 4,
																	display: 'flex',
																	alignItems: 'center',
																	justifyContent: 'center',
																}}
															>
																<PlusOutlined style={{ color: 'white' }} />
															</div>
														)
													}
												>
													<Panel
														forceRender={true}
														key={item?.Id}
														header={
															<div style={{ borderLeft: '6px solid #CC0000' }}>
																<span
																	className="ant-collapse-title-header"
																	style={{ color: '#181C32' }}
																>
																	{isMobileDevice()
																		? activeKeys.includes(item?.Id.toString())
																			? item?.Title
																			: item?.Title.length > 25
																			? item?.Title.substr(0, 25) + '...'
																			: item?.Title
																		: item?.Title}
																</span>
															</div>
														}
													>
														<span
															className="ant-collapse-content-description"
															style={{ color: '#5E6278', whiteSpace: 'pre-line' }}
															dangerouslySetInnerHTML={{ __html: item?.Description }}
														></span>
													</Panel>
												</Collapse>
											</Card>
										</Col>
										<Col xl={3} lg={24} md={24} sm={24} xs={24}></Col>
									</Row>
								)
							})}
					</div>
				</Col>
			</Row>
		</div>
	)
}
export default Service
